export const WORK_ORDERS_ENDPOINT = 'winter-service-work-orders'

// Where the vehicles of the marked orders are right now. Live data, so it is asked for
// on every marking rather than carried on the listing - see `useWorkOrderVehiclePositions`.
export const VEHICLE_POSITIONS_ENDPOINT = 'winter-service-work-orders/vehicle-positions'

// The irregularities the map marks. They are not reported against the order but
// against the task and the vehicle, so the listing is narrowed the same way the
// backend counts them - see `buildIrregularityFilters`.
export const IRREGULARITIES_ENDPOINT = 'irregularities'

export const WORK_ORDERS_OVERVIEW_TABLE_KEY = 'winter-service-v2-work-orders-overview'
export const WORK_ORDERS_OVERVIEW_UI_VIEW = 'winter_service2_work_orders_overview'

export const WORK_ORDER_STREETS_TABLE_KEY = 'winter-service-v2-work-order-streets'

export const WORK_ORDERS_OVERVIEW_INDEX_ROUTE = 'WinterService2WorkOrdersOverview'
export const WORK_ORDER_DETAILS_ROUTE = 'WinterService2WorkOrderDetails'

export const WORK_ORDERS_OVERVIEW_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/work_orders/overview'

// The tab keys TabsLayout locks the tabs by - stable and distinct, the way the task
// details screen keeps them.
export const WORK_ORDER_TASK_DATA_TAB_KEY = 'work_order_task_data'
export const WORK_ORDER_STREETS_TAB_KEY = 'work_order_streets'
export const WORK_ORDER_EXECUTION_TAB_KEY = 'work_order_execution'

export const WORK_ORDER_CANCEL_ENDPOINT = (workOrderId) => `${WORK_ORDERS_ENDPOINT}/${workOrderId}/cancel`

// The statuses a work order can be in, as the listing's status filter offers them. A
// fixed set of four, but served rather than hard-coded here: the ids are what the filter
// sends and they are the database's, not ours to guess.
export const WORK_ORDER_STATUSES_ENDPOINT = `${WORK_ORDERS_ENDPOINT}/statuses`

/**
 * The statuses an order can no longer be called off from: one that has been driven, and
 * one that has been called off already. They travel as `status.name` on the row.
 *
 * An order that is in progress is deliberately not among them - a crew can be called off
 * mid-shift, and a device that keeps reporting afterwards puts the order back in progress.
 */
export const WORK_ORDER_CLOSED_STATUSES = ['COMPLETED', 'CANCELLED']

// What the backend calls an order the dispatcher raised on the spot; everything else
// is part of the plan. It travels as `kind`, apart from the codebook types on the order.
export const WORK_ORDER_KIND = {
  regular: 'REGULAR',
  intervention: 'INTERVENTION'
}

// Work time comes off the backend in seconds; the screens read it in hours and minutes.
export const SECONDS_IN_MINUTE = 60
export const MINUTES_IN_HOUR = 60

// Metres come off the coverage snapshot, kilometres are what the table shows.
export const METRES_IN_KILOMETRE = 1000

// How the two counted figures are written out. A kilometre is worth a decimal - it is
// the difference between a side street and a run across town. A share of a route is
// not: the backend counts it to two decimals, and neither of them changes what anyone
// does about a route that is 96 % driven.
export const KILOMETRE_DECIMALS = 1
export const COVERAGE_PERCENT_DECIMALS = 0
